module.exports = __webpack_public_path__ + "media/images/bi-chevron-down-54da8a8a.svg";